module.exports = __webpack_public_path__ + "static/421-7b97b1b556bdbf925632a7693cd79c07.png";